module.exports = __webpack_public_path__ + "img/hezuo@2x.1f675432.png";